import { styled } from "@material-ui/core";

/**
 * The body for a dialog.
 *
 * Whilst not currently necessary, it should always be used to maintain consistency in later changes.
 *
 * All other props are passed to the root element.
 */
export const DialogBody = styled("div")(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
